import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import Paper from "@mui/material/Paper";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MenuIcon from "@mui/icons-material/Menu";
import useMediaQuery from "@mui/material/useMediaQuery";
import { FaDatabase } from "react-icons/fa";
import { IoDocuments } from "react-icons/io5";
import { MdError } from "react-icons/md";
import { IoIosList } from "react-icons/io";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Fab from "@mui/material/Fab";
import { IoLanguage } from "react-icons/io5";
import MasterData from "./MasterData";
import DocumentData from "./DocumentData";
import FaultRaiseComponent from "./FaultRaise";
import { toast } from "react-toastify";
import PublicWebsiteActions from "../../Actions/PublicWebsiteActions";
import PublicWebsiteConstants from "../../Constants/PublicWebsiteConstants";
import publicWebsiteStore from "../../Stores/PublicWebsiteStore";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";
import {
  useLanguageActionContext,
  useLanguageContext,
} from "../../Context/LanguageContext";
import LanguageSelector from "../Language/LanguageSelector";
import InspectionIndex from "../WebInspection/inspectionIndex";
import { useThemeActionsContext } from "../../Context/ThemeContext";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import OrderHistroy from "../Navigationsbar/Nav-Details/OrderHistroy";
import PublicInspections from "./PublicInspections";

function TabPanel(props) {
  const { children, value, index } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
    >
      {value === index && (
        <Box p={3}>
          <Typography component={"div"}>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  fab: {
    position: "fixed",
    bottom: theme.spacing(10),
    right: theme.spacing(2),
  },
  smallScreenHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(1),
    gap: theme.spacing(1),
  },
  languageSelectorSmall: {
    position: "static !important",
    bottom: "auto !important",
    right: "auto !important",
    minHeight: "40px",
    height: "40px",
  },
  listItemIcon: {
    minWidth: "22px",
    marginRight: theme.spacing(1),
  },
  listItemText: {
    margin: 0,
  },
  drawerListItem: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
}));

export default function SearchEquipment() {
  const classes = useStyles();
  const updateTheme = useThemeActionsContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const { language, localization } = useLanguageContext();
  const UpdateLanguage = useLanguageActionContext();
  const [equipmentDetails, setEquipmentDetails] = useState([]);
  const [value, setValue] = useState(0);
  const [newTabValue, setNewTabValue] = useState("");
  const [drawerOpen, setDrawerOpen] = useState(false);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const tag = queryParams.get("tag");

  const isSmallScreen = useMediaQuery("(max-width:600px)");

  const raiseTicketSuccessCallback = () => {
    setGlobalSpinner(true);
    sessionStorage.setItem("tag", tag);
    PublicWebsiteActions.GetEquipmentPublicInformationBytag(tag, language);
  };

  const tabs = [
    {
      id: "details",
      label: localization.detailsTab,
      icon: <FaDatabase />,
      panel: <MasterData equipmentDetails={equipmentDetails} />,
      disabled: false,
    },
    {
      id: "documents",
      label: localization.documentsTab,
      icon: <IoDocuments />,
      panel: <DocumentData documents={equipmentDetails.documents} />,
      disabled: false,
    },
    {
      id: "ticket",
      label: localization.ticketTab,
      icon: <MdError />,
      panel: (
        <FaultRaiseComponent
          equipmentDetails={equipmentDetails}
          raiseTicketSuccessCallback={raiseTicketSuccessCallback}
        />
      ),
      disabled: !equipmentDetails.canOpenTicket,
    },
    equipmentDetails.canCreateWebInspection && {
      id: "checklist",
      label: localization.checkList,
      icon: <IoIosList />,
      panel: (
        <InspectionIndex
          equipmentDetails={equipmentDetails}
          newTabValue={newTabValue}
          setValue={setValue}
          setNewTabValue={setNewTabValue}
        />
      ),
      disabled: false,
    },
    equipmentDetails.inspectionDisplaySetting !== "None" && {
      id: "inspections",
      label: localization.inspections,
      icon: <DescriptionOutlinedIcon />,
      panel: <PublicInspections equipmentDetails={equipmentDetails} />,
      disabled: false,
    },
  ].filter(Boolean);

  const handleChange = (event, newValue) => {
    const currentTabId = tabs[value]?.id;
    const nextTabId = tabs[newValue]?.id;

    // If switching from checklist tab and token exists
    if (currentTabId === "checklist" && nextTabId !== "checklist") {
      if (sessionStorage.getItem("token")) {
        // Store the desired tab value and let InspectionIndex handle the back action
        setNewTabValue(newValue);
      } else {
        // If no token, switch tab directly
        setValue(newValue);
      }
    } else {
      setValue(newValue);
    }
  };

  const handleMobileTabChange = (newValue) => {
    // Close the drawer
    setDrawerOpen(false);
    // Use the same handleChange logic
    handleChange(null, newValue);
  };

  useEffect(() => {
    updateTheme("default-theme");
    if (
      sessionStorage.getItem("tag") &&
      sessionStorage.getItem("tag") !== tag
    ) {
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("organization");
      sessionStorage.removeItem("username");
      sessionStorage.removeItem("userId");
    }
  }, []);

  useEffect(() => {
    if (queryParams.size > 0) {
      setGlobalSpinner(true);
      sessionStorage.setItem("tag", tag);
      PublicWebsiteActions.GetEquipmentPublicInformationBytag(tag, language);
    }
    UpdateLanguage(language);
    return () => {};
  }, [language, tag]);

  useEffect(() => {
    function getEquipPublicInfoSuccess() {
      var res = publicWebsiteStore.getEquipPublicInfoResult();
      if (res) {
        setEquipmentDetails(res);
      }
      setGlobalSpinner(false);
    }

    function getEquipPublicInfoFailure() {
      var res = publicWebsiteStore.getEquipPublicInfoResult();
      setGlobalSpinner(false);
      toast.error(res);
    }
    publicWebsiteStore.addChangeListener(
      PublicWebsiteConstants.GET_EQUIPMENT_PUBLIC_INFO_SUCCESS,
      getEquipPublicInfoSuccess
    );

    publicWebsiteStore.addChangeListener(
      PublicWebsiteConstants.GET_EQUIPMENT_PUBLIC_INFO_FAILURE,
      getEquipPublicInfoFailure
    );

    return () => {
      publicWebsiteStore.removeChangeListener(
        PublicWebsiteConstants.GET_EQUIPMENT_PUBLIC_INFO_SUCCESS,
        getEquipPublicInfoSuccess
      );

      publicWebsiteStore.removeChangeListener(
        PublicWebsiteConstants.GET_EQUIPMENT_PUBLIC_INFO_FAILURE,
        getEquipPublicInfoFailure
      );
    };
  }, []);

  return (
    <>
      <div className="container mainContainer p-0">
        <Paper square className={classes.root}>
          {!isSmallScreen && (
            <Fab
              color="primary"
              aria-label="add"
              variant="extended"
              className={classes.fab + " fabIconForLanguage"}
            >
              <LanguageSelector />
            </Fab>
          )}

          {isSmallScreen ? (
            <>
              <div className={classes.smallScreenHeader}>
                <IconButton
                  onClick={() => setDrawerOpen(true)}
                  style={{ margin: "0" }}
                >
                  <MenuIcon />
                </IconButton>

                <Typography
                  variant="h6"
                  component="div"
                  sx={{ flexGrow: 1, textAlign: "center", fontSize: "1.5rem" }}
                >
                  {tabs[value]?.label}
                </Typography>

                <Fab
                  color="primary"
                  aria-label="language"
                  variant="extended"
                  size="small"
                  className={
                    classes.languageSelectorSmall + " fabIconForLanguage"
                  }
                >
                  <LanguageSelector />
                </Fab>
              </div>

              <Drawer
                anchor="left"
                open={drawerOpen}
                onClose={() => setDrawerOpen(false)}
              >
                <List>
                  {tabs.map((tab, idx) => (
                    <ListItem
                      button
                      key={tab.id}
                      selected={value === idx}
                      onClick={() => handleMobileTabChange(idx)}
                      disabled={tab.disabled}
                      className={classes.drawerListItem}
                    >
                      <ListItemIcon className={classes.listItemIcon}>
                        {tab.icon}
                      </ListItemIcon>
                      <ListItemText
                        primary={tab.label}
                        className={classes.listItemText}
                      />
                    </ListItem>
                  ))}
                </List>
              </Drawer>
            </>
          ) : (
            <Tabs
              value={value}
              onChange={handleChange}
              variant="fullWidth"
              scrollButtons="auto"
              indicatorColor="secondary"
              textColor="secondary"
              aria-label="icon label tabs example"
            >
              {tabs.map((tab, idx) => (
                <Tab
                  key={tab.id}
                  icon={tab.icon}
                  label={tab.label}
                  disabled={tab.disabled}
                />
              ))}
            </Tabs>
          )}

          {tabs.map((tab, idx) => (
            <TabPanel key={tab.id} value={value} index={idx}>
              {tab.panel}
            </TabPanel>
          ))}
        </Paper>
        <footer className="publicWebsiteFooter">
          <div className="d-flex publicWebFooterCls">
            <div className="brandingHeader"></div>
            <div>{localization.poweredBy}</div>
          </div>
        </footer>
      </div>
    </>
  );
}
